import { toast } from "react-toastify";
import { panelAPI } from "../services/api";

export const usePanelDecision = (panelId, user, onSuccess) => {
  const createDecision = async (decisionNotes) => {
    if (!decisionNotes) {
      toast.error("Please provide decision notes");
      return false;
    }

    try {
      // Create decision in backend
      const decision = {
        panelId: parseInt(panelId),
        decision: "COMPLETED",
        summary: decisionNotes,
        deciderId: user?.id,
      };

      await panelAPI.createDecision(decision);

      // Update panel status
      await panelAPI.updatePanel(panelId, {
        status: "DECISION_REACHED",
        progress: 90,
      });

      toast.success(
        "Decision marked as complete. Admin has been notified for review."
      );

      // Mock alert for demo
      alert(
        "📧 Email Notification Sent to Platform Admin:\n\nPanel decision has been completed and requires your review."
      );

      if (onSuccess) {
        onSuccess();
      }

      return true;
    } catch (error) {
      console.error("Error saving decision:", error);
      toast.error("Failed to save decision");
      return false;
    }
  };

  return {
    createDecision,
  };
};
